<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
        <div class="col green">
          <h3>
            <h3><i class="fas fa-hand-holding-heart"></i> Insurance Report</h3>
          </h3>
        </div>
        <div class="text-right">
          <label class="custom-toggle">
            <input v-model="insuranceBuyOrSell" type="checkbox" @change="setInsuranceReportData" id="insuranceCheck" />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div class="chart">
        <canvas id="insuranceChart"></canvas>
      </div>
      <a href @click="showPopup" class="view-more">View More<i class="fa fa-arrow-circle-right" ></i></a>
      <!-- <a href class="text-right view-more" @click="showPopup">View More</a> -->
    </div>
    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-xl"
      id="chartViewMoreInsurance"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Insurance Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="col-lg-9 col-5 tradeDate">
                <!-- <h4>Trade Date Range</h4>
                <form>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">From</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupFromDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupMaturityReportData"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">To</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupToDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupMaturityReportData"
                    />
                  </div>
                </form> -->
              </div>
               <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input type="checkbox" v-model="popupInsuranceBuyOrSell" @change="setPopupInsuranceReportData">
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
              <!-- <div class="text-right">
                <label class="custom-toggle">
                  <input
                    v-model="popupInsuranceBuyOrSell"
                    type="checkbox"
                    @change="setPopupInsuranceReportData"
                  />
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
              </div> -->
            </div>
            <div class="graph">
              <canvas id="popupInsuranceChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
export default {
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getInsuranceReportData();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      insuranceBuyOrSell: false,
      insuranceChartOptions: chartConstants.insuranceBarChartDefault,
      insuranceChartData: {},
      popupInsuranceChartOptions: chartConstants.insuranceChartDefaultPopup,
      popupInsuranceChartData: {},
      popupInsuranceBuyOrSell: false,
      myChart : null,
      myChartPoup :null
      // popupFromDate: this.fromdate,
      // popupToDate: this.todate
    };
  },
  methods: {
    getInsuranceReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/insurer?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True",
          auth
        )
        .then(result => {
          this.insuranceChartData = result.data.data;
          this.setInsuranceReportData();
        });
    },
    setInsuranceReportData() {
      this.insuranceChartOptions.data.labels = this.insuranceBuyOrSell ? this.insuranceChartData.sellsInsurers : this.insuranceChartData.buysInsurers ;
      this.insuranceChartOptions.data.datasets[0].data = this.insuranceBuyOrSell
        ? this.insuranceChartData.sells
        : this.insuranceChartData.buys;

      if(this.myChart){
        this.myChart.destroy();
      } 
      const ctx = document.getElementById("insuranceChart");
      this.myChart = new window.Chart(ctx, {
        type: this.insuranceChartOptions.type,
        data: this.insuranceChartOptions.data,
        options: this.insuranceChartOptions.options
      });
    },
    getPopupInsuranceReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/insurer?fromDate=" +
             this.fromdate  +
            "&toDate=" +
             this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.popupInsuranceChartData = result.data.data;
          this.setPopupInsuranceReportData();
        });
    },
    setPopupInsuranceReportData() {
      this.popupInsuranceChartOptions.data.labels = this.popupInsuranceBuyOrSell ? this.popupInsuranceChartData.sellsInsurers : this.popupInsuranceChartData.buysInsurers  
      this.popupInsuranceChartOptions.data.datasets[0].data = this
        .popupInsuranceBuyOrSell
        ? this.popupInsuranceChartData.sells
        : this.popupInsuranceChartData.buys;

      if(this.myChartPoup){
        this.myChartPoup.destroy();
      }   
      const ctx = document.getElementById("popupInsuranceChart");
       this.myChartPoup = new window.Chart(ctx, {
        type: this.popupInsuranceChartOptions.type,
        data: this.popupInsuranceChartOptions.data,
        options: this.popupInsuranceChartOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      this.getPopupInsuranceReportData();
      window.$("#chartViewMoreInsurance").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getInsuranceReportData();
      }
    });
  }
};
</script>